import React from 'react';

interface EditHeaderProps {
  mode: 'create' | 'edit';
}

const EditHeader: React.FC<EditHeaderProps> = ({ mode }) => (
  <div className="page-header-container">
    <div className="display-flex align-items-center gap-10">
      <h2 className="margin-0">{mode === 'edit' ? 'Editar desafio' : 'Criar desafio'}</h2>
    </div>
  </div>
);

export default EditHeader; 